import { zonaDelLocal } from './formato'

/**
 * Ahora, en la hora del LOCAL.
 *
 * Existe para la vigencia de las promociones, que se define en la hora del
 * mostrador: «los miércoles de 18 a 20». El motor de precios recibe un `Date`
 * y le pregunta el día y la hora con los getters locales, así que si se le
 * pasa `new Date()` la promo se activa según la zona del NAVEGADOR: en una PC
 * en UTC —vienen así de fábrica— la promo de la tarde arranca a las tres, y
 * una promo «los miércoles» empieza el martes a las nueve de la noche.
 *
 * El servidor evalúa con la zona del local, así que sin esto la pantalla y el
 * cobro pueden discrepar: el cajero ve un precio y la caja cobra otro.
 *
 * Lo que devuelve es un `Date` cuyos getters LOCALES dan la hora de pared del
 * local. No es el mismo instante —está corrido a propósito—, y por eso solo
 * sirve para preguntarle día y hora, nunca para guardar ni para mandar al
 * servidor.
 */
export function momentoDelLocal(ahora: Date = new Date()): Date {
  const zona = zonaDelLocal()
  if (!zona) return ahora

  try {
    // `en-CA` da ISO (2026-09-08) y evita tener que interpretar el orden de
    // día y mes de cada locale.
    const partes = new Intl.DateTimeFormat('en-CA', {
      timeZone: zona,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(ahora)

    const p = (tipo: Intl.DateTimeFormatPartTypes) =>
      Number(partes.find((x) => x.type === tipo)?.value ?? '0')

    // `hour` puede venir 24 a la medianoche en algunos motores: el 24 del día
    // 8 es el 0 del 9, y `new Date` lo normaliza solo.
    return new Date(p('year'), p('month') - 1, p('day'), p('hour'), p('minute'), p('second'))
  } catch {
    // Una zona que este navegador no conoce no puede dejar el POS sin
    // promociones: se sigue con el reloj del navegador.
    return ahora
  }
}
